export const apiConstants = {
  register: "/api/register",
  reset: "/api/password/reset",
  forgot: "/api/password/forgot"
};
